'use client'
import Link from 'next/link'
import posthog from 'posthog-js'

interface Props extends React.ComponentProps<typeof Link> {
  eventName: string
  eventProperties?: Record<string, unknown>
}

export function TrackedLink({ eventName, eventProperties, onClick, ...props }: Props) {
  return (
    <Link
      {...props}
      onClick={(e) => {
        posthog.capture(eventName, eventProperties)
        onClick?.(e)
      }}
    />
  )
}
